import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import { filterUrl } from "../config/config";

// ---- Label Map ----
const LABEL_MAP = {
  brand: "Brand",
  spare: "Spares",
  sort: "Sort",
  price: "Price Range",
};

// ---- Entity Adapter ----
const mastersFilterListAdapter = createEntityAdapter({
  selectId: (filter) => filter.filter,
});

// ---- Initial State ----
const initialState = mastersFilterListAdapter.getInitialState();

// ---- RTK Query Slice ----
export const filterSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMasterFilters: builder.query({
      query: ({ category }) => filterUrl(category),

      transformResponse: (responseData) => {
        let filters = responseData.data;

        // 1️⃣ Add label to each filter
        filters = filters.map((f) => ({
          ...f,
          label: LABEL_MAP[f.filter] ?? f.filter, // fallback to original
        }));

        // 2️⃣ Remove unwanted filters (optional)
        const cleaned = filters.filter(
          (f) => f.filter !== "sort" && f.filter !== "price"
        );

        // 3️⃣ Normalize with Entity Adapter
        return mastersFilterListAdapter.setAll(initialState, cleaned);
      },

      providesTags: (result, error, arg) => {
        const tagType = `${arg.category}filters`;

        if (!result) return [{ type: tagType, id: tagType }];

        return [
          { type: tagType, id: tagType },
          ...result.ids.map((id) => ({ type: tagType, id })),
        ];
      },
    }),
  }),
});

export const { useGetMasterFiltersQuery } = filterSlice;

// ---- Selectors ----
const selectors = mastersFilterListAdapter.getSelectors();
export const selectAllMasterFilters = selectors.selectAll;
export const selectMasterFilterById = selectors.selectById;
